import { pick, set } from 'lodash';
import { AnyObject, RecordType } from '@xbcb/shared-types';
import { transformWorkOrderBase } from '../base';
import { transformLines } from './lines';
import { getRecordType } from '@xbcb/core';
export * from './lines';

export const transformUsConsumptionEntry = {
  toForm: ({ existingRecord }: { existingRecord: AnyObject }) => {
    const newRecord = transformWorkOrderBase.toForm({ existingRecord });
    if (newRecord.arrival?.inBond) {
      newRecord.arrival.isIt = true;
    }
    if (newRecord.exam?.containers) {
      const transformedContainers = newRecord.exam.containers.map(
        (container: { number: string }) => container.number,
      );
      newRecord.exam.containers = transformedContainers;
    }
    newRecord.invoices?.forEach((invoice: any) => {
      set(invoice, ['currency'], invoice.value?.currency);
      invoice.products?.forEach((product: any) => {
        transformLines.toForm({ lines: product.lines });
      });
    });
    const continuousBonds = newRecord.ior?.usIor?.continuousBonds; // TODO refactor RecordSelect nesting to fix this.
    if (continuousBonds) {
      newRecord.ior.continuousBonds = continuousBonds;
    }
    return newRecord;
  },
  toSchema: ({
    input,
    existingRecord,
  }: {
    input: AnyObject;
    existingRecord: AnyObject;
  }) => {
    const cleanedOutput = transformWorkOrderBase.toSchema({
      input,
      existingRecord,
    });
    delete cleanedOutput.broker;
    delete cleanedOutput.arrival?.isIt;
    delete cleanedOutput.ior?.continuousBonds; // we don't transmit this field, but we need to fetch it and keep it in the form to know whether to render the Bond tab.
    delete cleanedOutput.badges;
    if (cleanedOutput.exam?.containers) {
      cleanedOutput.exam.containers = cleanedOutput.exam.containers.map(
        (examContainerNumber: string) => {
          const foundContainer = cleanedOutput.containers?.find(
            (container: { number: string }) =>
              container.number === examContainerNumber,
          );
          return foundContainer || { number: examContainerNumber };
        },
      );
    }
    cleanedOutput.invoices?.forEach((invoice: any) => {
      delete invoice.currency;

      invoice.products?.forEach((product: any) => {
        delete product.totalReporting;
        // Strip weight/volume fields that have no value (stale unit from HiddenField)
        if (product.grossWeight && !product.grossWeight.value) {
          delete product.grossWeight;
        }
        if (product.netWeight && !product.netWeight.value) {
          delete product.netWeight;
        }
        if (product.grossVolume && !product.grossVolume.value) {
          delete product.grossVolume;
        }
        if (product.product) {
          product.product = pick(product.product, ['id', 'version']);
        }
        transformLines.toSchema({ lines: product.lines });
      });
    });
    if (cleanedOutput.ior?.usIor) {
      // usIor is an IdVersion input
      cleanedOutput.ior.usIor = pick(cleanedOutput.ior.usIor, [
        'id',
        'version',
      ]);
    }
    const { mailing, physical } = cleanedOutput.ior?.addresses || {};
    if (mailing || physical) {
      cleanedOutput.ior.address = mailing || physical;
    }
    cleanedOutput.tags = [...existingRecord.tags];
    delete cleanedOutput.ior?.addresses;
    // adding this check because this transformer is used for non UsConsumptionEntry Records as well
    if (getRecordType(existingRecord.id) === RecordType.US_CONSUMPTION_ENTRY) {
      const keepStoredInvoices =
        !cleanedOutput.invoices?.length &&
        Boolean(existingRecord.invoicesReference);
      if (keepStoredInvoices) {
        delete cleanedOutput.invoices;
        delete cleanedOutput.invoicesReference;
      } else {
        cleanedOutput.invoicesReference = null;
      }
    }
    // tariffType is not a field on UsPostSummaryCorrectionTariffInput, so strip
    // it for PSC to avoid the update mutation being rejected.
    if (
      getRecordType(existingRecord.id) === RecordType.US_POST_SUMMARY_CORRECTION
    ) {
      cleanedOutput.invoices?.forEach((invoice: AnyObject) =>
        invoice.products?.forEach((product: AnyObject) =>
          product.lines?.forEach((line: AnyObject) =>
            line.tariffs?.forEach((tariff: AnyObject) => {
              delete tariff.tariffType;
            }),
          ),
        ),
      );
    }
    return cleanedOutput;
  },
};
